const createType = (perfix: string) => {
  return {
    REQUEST: perfix + '_REQUEST',
    SUCCESS: perfix + '_SUCCESS',
    FAILED: perfix + '_FAILED'
  };
};

// export const SEARCH_CUSTOMER_NAME = createType('SEARCH_CUSTOMER_NAME');
export const CONTACT_LIST = createType('CONTACT_LIST');
export const CONTACT_UPDATE = createType('CONTACT_UPDATE');
